// extracted by mini-css-extract-plugin
module.exports = {"purchaseCompleteMessage":"PaymentModalMessage-module--purchaseCompleteMessage--2V-Rp","lastStep":"PaymentModalMessage-module--lastStep--1y6cV"};